/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardRequestModel } from '../../models/dashboard-request-model';
import { OrgAdminScanSuccessItemModel } from '../../models/org-admin-scan-success-item-model';

export interface OrgAdminScanSuccessOrganizationIdPost$Params {
  organizationId: string;
      body?: DashboardRequestModel
}

export function orgAdminScanSuccessOrganizationIdPost(http: HttpClient, rootUrl: string, params: OrgAdminScanSuccessOrganizationIdPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<Array<OrgAdminScanSuccessItemModel>>> {
  const rb = new RequestBuilder(rootUrl, orgAdminScanSuccessOrganizationIdPost.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<Array<OrgAdminScanSuccessItemModel>>;
    })
  );
}

orgAdminScanSuccessOrganizationIdPost.PATH = '/OrgAdmin/ScanSuccess/{organizationId}';
